import type { JSX } from 'react'
import type { ITextBoxProps } from '../TextBox'

import { TextBox } from '../TextBox'
import { Colors, TextBoxTypes } from '../TextBox.h'

export interface ITextBoxCaption4SecondaryProps extends ITextBoxProps {}

export const TextBoxCaption4Secondary = ({
  title,
  color = Colors.TEXT_ICON_SECONDARY,
  font = TextBoxTypes.Caption4,
  ...rest
}: ITextBoxCaption4SecondaryProps): JSX.Element => (
  <TextBox title={title} color={color} font={font} {...rest} />
)
